import { render, staticRenderFns } from "./NsHeaderNotNav.vue?vue&type=template&id=48ff5384&scoped=true&"
import script from "./NsHeaderNotNav.vue?vue&type=script&lang=js&"
export * from "./NsHeaderNotNav.vue?vue&type=script&lang=js&"
import style0 from "./NsHeaderNotNav.vue?vue&type=style&index=0&id=48ff5384&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ff5384",
  null
  
)

export default component.exports